import { FINGERPRINTABLE_METADATA } from './constant';
export function isFingerprintable(arg) {
    if (arg !== null && typeof arg === 'object') {
        return Reflect.hasMetadata(FINGERPRINTABLE_METADATA, arg);
    }
    return false;
}
export function getFingerprintOrUndefined(arg) {
    if (isFingerprintable(arg)) {
        return arg.getFingerprint();
    }
}
//# sourceMappingURL=util.js.map